// @flow
/*
    Generic tags to be used how you feel (in forms, searches, wherever)
 */

import React from 'react';
import classnames from 'classnames/bind';
import s from './Tags.styl';

const cx = classnames.bind(s);

/*
  A simple tag, displays a string, does not have a remove button
 */

type TagProps = {
  tagLabel: String,
};

export class Tag extends React.Component {
  props: TagProps;
  render() {
    const {tagLabel} = this.props;

    // TODO:REFACTOR
    return (
      <div className={cx('tag')}>
        <span className={cx('tag-label')}>{tagLabel}</span>
      </div>
    );
  }
}

/*
  A tag with an X icon on the left that allows remove funcionality to be provided by whomever uses it
 */

type RemovableTagProps = {
  onRemove: Function,
  tagLabel: String,
};

export class RemovableTag extends React.Component {
  props: RemovableTagProps;
  render() {
    const {tagLabel, onRemove} = this.props;

    return (
      <div className={cx('removable-tag')}>
        <span className={cx('close-btn')} onClick={onRemove}>×</span>
        <span className={cx('tag-label')}>{tagLabel}</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./web_modules/trustar/components/Tags.js